function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#6366F1"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.64 25.161A3.758 3.758 0 0 1 48.044 23h16.073a3.74 3.74 0 0 1 3.22 1.81l34.134 56.575c.7 1.15.7 2.582.042 3.733a3.762 3.762 0 0 1-3.263 1.88h-16.8a3.775 3.775 0 0 1-2.66-1.08A43.813 43.813 0 0 0 56.176 74.45c-9.52-1.53-20.735.562-31.782 11.467a3.79 3.79 0 0 1-4.788.421 3.685 3.685 0 0 1-1.26-4.603l26.28-56.575h.014Zm9.941 5.263L83.605 79.56h8.036L61.987 30.438h-7.406v-.014Zm15.247 40.547-21.38-36.224-17.08 36.743a40.754 40.754 0 0 1 26.013-4.35c4.48.701 8.68 2.105 12.447 3.83Z"
});
function SvgDiko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiko);
export default __webpack_public_path__ + "static/media/DIKO.895e3a7d99ea9a273e559aafdb66eb28.svg";
export { ForwardRef as ReactComponent };